import { compose } from "recompose";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded, getVal } from "react-redux-firebase";
import RegionsForm from 'components/Regions/RegionsForm'
import { createRegion, updateRegion, deleteRegion } from "actions/regions/regionsActions";
import * as routes from "constants/routes";

const handleFormSubmit = props => (formValues) => {
  return props.updateRegion(formValues).then(() => {
    props.history.push(routes.REGIONS);
  });
};

const mapStateToProps = (state, ownProps) => {
  const { firestore, firebase } = state;

  const docId = ownProps.match.params.id;
  const regions = firestore.data.regions;
  const region = getVal(regions, docId);
  const auth = firebase.auth;

  const error = state.regions.error;
  const initialValues = { ...region };

  const isLoading = !isLoaded(regions);

  return {
    isLoading: isLoading,
    initialValues: initialValues,
    onSubmit: handleFormSubmit(ownProps),
    isEditing: true,
    auth: auth,
    error: error
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const docId = ownProps.match.params.id;
  return {
    createRegion: formValues => dispatch(createRegion(formValues)),
    updateRegion: formValues => dispatch(updateRegion(docId, formValues)),
    deleteRegion: () => dispatch(deleteRegion(docId))
  };
};

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
  firestoreConnect([
    { collection: "regions" },
  ]),
  connect(mapStateToProps)
)(RegionsForm);
